import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { AuthorizationTokenService } from '../services/authorization-token.service';

@Injectable()
export class AuthorizationTokenInterceptor implements HttpInterceptor {
  constructor(private authorizationTokenService: AuthorizationTokenService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authorizationTokenService.authorizationToken$.pipe(
      first(),
      switchMap((authorizationToken) => {
        if (authorizationToken != null) {
          const changedReq = req.clone({ setHeaders: { Authorization: `Bearer ${authorizationToken}` } });
          return next.handle(changedReq);
        }
        return next.handle(req);
      }),
    );
  }
}
